import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useUserAuth } from '@/providers/UserAuthProvider';
import { LogIn, LogOut, User } from 'lucide-react';
import { AuthModal } from '@/components/auth/AuthModal';

export function AdminLogin() {
  const { user, logout } = useUserAuth();
  const [authOpen, setAuthOpen] = useState(false);

  if (user) {
    return (
      <div className="flex items-center gap-3 p-3 bg-gradient-to-r from-green-500/10 to-emerald-500/10 border border-green-500/20 rounded-lg">
        <div className="flex items-center gap-2 flex-1">
          <div className="h-8 w-8 rounded-full bg-green-500/20 flex items-center justify-center">
            <User className="h-4 w-4 text-green-500" />
          </div>
          <div className="flex flex-col">
            <span className="text-sm font-medium text-green-500">Logged In</span>
            <span className="text-xs text-muted-foreground truncate max-w-[200px]">
              {user.email}
            </span>
          </div>
        </div>
        <Button
          variant="outline"
          size="sm"
          onClick={logout}
          className="flex items-center gap-2"
        >
          <LogOut className="h-4 w-4" />
          Logout
        </Button>
      </div>
    );
  }

  return (
    <>
      <Button
        onClick={() => setAuthOpen(true)}
        className="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700"
      >
        <LogIn className="h-4 w-4" />
        Login
      </Button>
      <AuthModal open={authOpen} onOpenChange={setAuthOpen} />
    </>
  );
}
